import { useState } from 'react';
import { decideAgentApproval } from '../../../../services/api/todoApi';

export default function useAgentApprovalDecision({companyId,item,onResolved}) {
    const [busy,setBusy]=useState(null),[error,setError]=useState(null);
    const decide=async decision=>{
        setBusy(decision);setError(null);
        const plan=item.resolvedPlan;
        const binding=plan?.contract==='bank-reconciliation/1'?{
            company_id:companyId,approval_id:item.approvalId,action_id:plan.action_id,
            plan_hash:plan.plan_hash,bank_generation:plan.bank.generation
        }:undefined;
        try {await decideAgentApproval(companyId,item.approvalId,decision,binding);onResolved();}
        catch(e){
            const status=e.response?.status;
            setError(status===403?(e.response?.data?.error||'Behörighet saknas')
                :status===409?'Redan hanterad'
                :e.response?.data?.error||'Kunde inte genomföras — försök igen');
            if(status===409)onResolved(); // someone else decided — refresh the list
            // commit_failed is terminal (the agent re-stages) — refresh so the row clears.
            if(e.response?.data?.outcome==='commit_failed')setTimeout(onResolved,2500);
        }
        finally{setBusy(null);}
    };
    return {busy,error,decide};
}
